import React from 'react'
import PropTypes from 'prop-types'
import CurrencyTextBoxATM from './currency_text_box_atm'
import CurrencyTextBoxRegular from './currency_text_box_regular'
import { getJSONFromScript } from 'lib/server_params'
import { getDecimalPrecision, getDecimalSeparator } from 'client/griffin'

const isiOS = !!getJSONFromScript('store').device_info.osiOs

class CurrencyTextBox extends React.Component {
  static propTypes = {
    atmInput: PropTypes.bool,
    currencyCode: PropTypes.string,
    decimalDigits: PropTypes.number,
    decimalDot: PropTypes.string,
  }

  render() {
    let { atmInput, ...propsToPass } = this.props
    if (atmInput == null) {
      atmInput = isiOS
    }

    Object.assign(propsToPass, {
      decimalDigits:
        this.props.decimalDigits != null
          ? this.props.decimalDigits
          : getDecimalPrecision(this.props.currencyCode),
      decimalDot:
        this.props.decimalDot != null
          ? this.props.decimalDot
          : getDecimalSeparator(this.props.currencyCode),
    })

    if (atmInput) {
      return <CurrencyTextBoxATM {...propsToPass} />
    }
    return <CurrencyTextBoxRegular {...propsToPass} />
  }
}

export default CurrencyTextBox
